module.exports = __webpack_public_path__ + "img/67.fd8a99d3.webp";